import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1301Model } from './kymw1301.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { ClassificationsListComponent } from '../../../commons/kymw02/list/classifications-list/classifications-list.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { KYMW1301CatalogDataCsvModel } from './vo/kymw1301-catalog-data-csv.model';
import { GetPlanCSVService } from './api-services/get-plan-csv.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { GetFeatureThemaListService } from './api-services/get-feature-thema-list.service';

/**
 * 企画書データ出力画面を管理するクラス
 *
 * @export KYMW1301Component
 * @class KYMW1301Component
 */
@Component({
  selector: 'app-kymw1301',
  templateUrl: 'kymw1301.component.html',
  styleUrls: ['kymw1301.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1301Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txti_OrderCodeFrom', { static: true }) txti_OrderCodeFrom: OrderCodeTextInputComponent;
  @ViewChild('txti_OrderCodeTo', { static: true }) txti_OrderCodeTo: OrderCodeTextInputComponent;
  @ViewChild('lst_Classifications', { static: true }) lst_Classifications: ClassificationsListComponent;

  // 親画面からの連携値
  param: any;

  kymw1301Model: KYMW1301Model = new KYMW1301Model();

  /**
   *Creates an instance of KYMW1301Component.
   * @param {PlessDialogService} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1301Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getPlanCSVService: GetPlanCSVService,
    private getFeatureThemaListService: GetFeatureThemaListService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1301Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1301';
  }

  /**
   * 受注コード・媒体区分変更
   */
  public eventOrderCodeMediumType_CHANGEHandler() {
    // 特集コードの選択をクリアする
    this.kymw1301Model.selectFeatureCode = "";

    // 受注コード(From)、受注コード(To)、媒体の全てに入力がある場合、特集コード取得
    if ( 
      this.txti_OrderCodeFrom.isValidOrderCode() &&
      this.txti_OrderCodeTo.isValidOrderCode() &&
      this.kymw1301Model.mediumType
    ) {
      this.getFeatureThemaListService.execute(this.kymw1301Model, (data) => {
        this.kymw1301Model.setfeatureThemaList(data);
      });

    } else {
      // いずれか未入力の場合、リストの内容を空にする
      this.kymw1301Model.featureThemaList = null;
    }
  }

  /**
   * 出力ボタン押下時
   * 
   * @memberof KYMW1301Component
   */
  public eventOut_CLICKHandler(): void {
    // 入力チェック
    if (this.inputCheck() === false) {
      return;
    }

    const reqVO: KYMW1301CatalogDataCsvModel = this.createCatalogDataCsvVO();

    // 企画書データ出力API呼び出し
    this.getPlanCSVService.execute(this.kymw1301Model, reqVO,
      (data: any) => this.getPlanCSVServiceSuccessFunc(data));
  }

  /**
   * 入力チェック
   *
   * @return true:OK false:NG
   */
  private inputCheck(): boolean {
    let replaceArray: Array<string> = new Array<string>();

    // 必須チェック： 受注コード(From)
    if (PlessViewUtilsSub.isEmpty(this.kymw1301Model.orderCodeFrom)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード(From)'], () => { });
      return false;
    }

    // 必須チェック： 受注コード(To)
    if (PlessViewUtilsSub.isEmpty(this.kymw1301Model.orderCodeTo)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード(To)'], () => { });
      return false;
    }

    // 妥当性チェック：受注コード(From)
    if (!this.txti_OrderCodeFrom.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('W0024', ['受注コード(From)'], () => { });
      return false;
    }

    // 妥当性チェック：受注コード(To)
    if (!this.txti_OrderCodeTo.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('W0024', ['受注コード(To)'], () => { });
      return false;
    }

    // 受注コード大小チェック
    if (this.kymw1301Model.orderCodeFrom > this.kymw1301Model.orderCodeTo) {
      replaceArray = new Array<string>();
      replaceArray.push('受注コード(From)');
      replaceArray.push('受注コード(To)');

      this.dialogService.openAlertGetMessage('E0125', replaceArray, () => { });
      return false;
    }

    // 必須チェック： 部門コード
    if (PlessViewUtilsSub.isEmptyArray(this.lst_Classifications.selectedItems)) {
      this.dialogService.openAlertGetMessage('W0001', ['部門コード'], () => { });
      return false;
    }

    // ページ大小チェック
    if (
      this.kymw1301Model.pageNumFrom && this.kymw1301Model.pageNumTo &&
      Number(this.kymw1301Model.pageNumFrom) > Number(this.kymw1301Model.pageNumTo) ) {
      replaceArray = new Array<string>();
      replaceArray.push('ページ(From)');
      replaceArray.push('ページ(To)');

      this.dialogService.openAlertGetMessage('E0125', replaceArray, () => { });
      return false;
    }
    return true;
  }

  /**
   * 企画書データ出力VO初期化
   *
   * @private
   * @returns {KYMW1301CatalogDataCsvModel}
   * @memberof KYMW1301Component
   */
  private createCatalogDataCsvVO(): KYMW1301CatalogDataCsvModel {
    const returnVO: KYMW1301CatalogDataCsvModel = new KYMW1301CatalogDataCsvModel();
    const list: Array<string> = new Array<string>();                            // 選択部門コードリスト

    // 選択部門コードリストを取得
    for (const item of this.lst_Classifications.selectedItems) {
      list.push(item);
    }

    returnVO.orderCodeFrom = this.kymw1301Model.orderCodeFrom;
    returnVO.orderCodeTo = this.kymw1301Model.orderCodeTo;
    returnVO.pCode = this.kymw1301Model.pCode;
    returnVO.mediumType = this.kymw1301Model.mediumType;
    returnVO.coopCode = this.kymw1301Model.coopCode;
    returnVO.pageNumFrom = this.kymw1301Model.pageNumFrom;
    returnVO.pageNumTo = this.kymw1301Model.pageNumTo;
    returnVO.orderNum = this.kymw1301Model.orderNum;
    returnVO.featureCode = this.kymw1301Model.selectFeatureCode;
    returnVO.markCode1 = this.kymw1301Model.markCode1;
    returnVO.markCode2 = this.kymw1301Model.markCode2;
    returnVO.markCode3 = this.kymw1301Model.markCode3;
    returnVO.markCode4 = this.kymw1301Model.markCode4;
    returnVO.markCode5 = this.kymw1301Model.markCode5;
    returnVO.wPublishFlag = this.kymw1301Model.wPublishFlag ? '1': '0';
    returnVO.multiPublishFlag = this.kymw1301Model.multiPublishFlag ? '1': '0';
    
    returnVO.classificationsList = list;

    return returnVO;
  }

  /**
   * 企画書データ出力API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1301Component
   */
  public getPlanCSVServiceSuccessFunc(data: any) {
    // ファイル名の設定
    const fileName = '企画書データ_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD') + '.CSV';

    // ファイルダウンロード
    this.fileDownloadConfirmService.show(data.FileName, fileName);
  }
}
